<template>
  <div class="wrapper">

    <div class="loading" v-if="loading">
      <Loader/>
    </div>

    <div class="content" v-if="!loading">
      <Nav :fixed="false" :bottomNav="true">
        <template v-slot:logo-box>
          <Logo scaleMode="playMode"/>
        </template>
        <template v-slot:options-box>
          <DialoguesButton scaleMode="playMode"/>
          <TitleInput :title="data.title" @onChange="changeTitle"/>
          <SaveButton @onSave="onSave" ref="saveButton"/>
        </template>
        <template v-slot:play-modes-box>
          <PlayModesButtonsEditor mode="create" @onPlayMode="onPlayMode"/>
        </template>
        <template v-slot:account-box>
          <AccountButton/>
        </template>
        <template v-slot:bottom-bar-box>
          <TitleInput :title="data.title" :mobile="true" @onChange="changeTitle"/>
        </template>
      </Nav>

      <div class="editor">
        <QuestionFrame
          :ref="question.id"
          v-for="(question, index) in data.bots"
          :data="getFrameData(question.id)"
          :key="question.id"
          :bottomBars="bottomBars"
          :questionIndex="index"
          :backgroundStore="data.backgroundStore"
          :personStore="data.personStore"
          @changeBottomBar="changeBottomBar"
          :questions="data.bots"
          :answers="data.answers"
          @goQuestion="goQuestion"
          @deleteQuestion="deleteQuestion"
        />
      </div>
    </div>

  </div>
</template>

<script>
import alert from '@/lib/alert'
import swal from 'sweetalert'
import axios from 'axios'
import uniqid from 'uniqid'
import { mapActions } from 'vuex';
import Loader from '@/components/Loader'

//Nav
import Nav from '@/components/Nav/Nav'
import Logo from '@/components/Nav/Logo'
import DialoguesButton from '@/components/Nav/DialoguesButton'
import PlayModesButtonsEditor from '@/components/Nav/PlayModesButtonsEditor'
import AccountButton from '@/components/Nav/AccountButton'
import SaveButton from '@/components/Nav/SaveButton'
import TitleInput from '@/components/Nav/TitleInput'

import QuestionFrame from '@/components/EditTree/QuestionFrame'

export default {
  name: 'CreateTree',
  data() {
    return {
      autoSaveTimeout: null,
      loading: true,
      data: {},
      bottomBars: {
        question: false,
        answer_0: false,
        answer_1: false,
        answer_2: false,
        answer_3: false,
      }
    }
  },
  components: {
    //Nav
    Nav,
    Logo,
    DialoguesButton,
    PlayModesButtonsEditor,
    AccountButton,
    SaveButton,
    TitleInput,
    //
    QuestionFrame,
    Loader
  },
  methods: {
    ...mapActions('player', ['playerStop']),
    ...mapActions('alerts', ['setError']),
    autoSave() {
      if(this.$router.currentRoute.name == 'Edit') {
        console.log('----AUTOSAVE----');
        clearTimeout(this.autoSaveTimeout);
        this.save();
        this.autoSaveTimeout = setTimeout(this.autoSave, 30000);
      } else {
        clearTimeout(this.autoSaveTimeout);
        console.log('----AUTOSAVE DELETED----');
      }
    },
    onClearTimeout() {
      clearTimeout(this.autoSaveTimeout);
    },
    onPlayMode(mode) {
      this.playerStop();
      this.onClearTimeout();
      this.save().then(() => {
        this.$router.push(`/${mode}?exercise_id=${this.data._id}`);
      });
    },
    onSave() {
      this.playerStop();
      this.onClearTimeout();
      this.save().then(() => {
        this.$refs.saveButton.saved();
      }).catch(err => {
        this.$refs.saveButton.saved();
        if(err == 'tooLarge') {
          swal("Too large!", "Reduce the exercise size to save it!", "error");
        }
      })
    },

    changeTitle(value) {
      this.data.title = value;
    },

    save() {
      return new Promise((resolve, reject) => {
        let title = this.data.title;
        if(title == '') {
          title = 'Untitled exercise';
        }

        // Filter BackgroundStore
          let botWithUploadBg = this.data.bots.filter(bot => {
            return bot.background.type == 'upload';
          })
          let backgroundsInUse = botWithUploadBg.map(bot => {
            return bot.background.data;
          })
          let cleanBackgroundStore = this.data.backgroundStore.filter(background => {
            return backgroundsInUse.includes(background.name);
          })
        // END

        // Filter PersonStore
          let botWithUploadPerson = this.data.bots.filter(bot => {
            return bot.person.type == 'upload';
          })
          let PersonsInUse = botWithUploadPerson.map(bot => {
            return bot.person.data;
          })
          let cleanPersonStore = this.data.personStore.filter(person => {
            return PersonsInUse.includes(person.name);
          })
        // END

        //Auto change Bot Audio
          let fixBots = JSON.parse(JSON.stringify(this.data.bots));
          fixBots.forEach(bot => {
            if(bot.audioType == 'bot' && bot.text == '') {
              bot.audioType = null;
            }
            if(bot.audioType == 'micro' && bot.recordingTime == 0) {
              bot.audioType = null;
            }
          })
        //END

        //Auto change Answer Audio
          let fixAnswers = JSON.parse(JSON.stringify(this.data.answers));
          fixAnswers.forEach(answer => {
            if(answer.audioType == 'bot' && answer.text == '') {
              answer.audioType = null;
            }
            if(answer.audioType == 'micro' && answer.recordingTime == 0) {
              answer.audioType = null;
            }
          })
        //END

        if(this.data._id) {
          axios({
            method: 'post',
            url: `${process.env.VUE_APP_SERVER_URL}changeExercise`,
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('token') 
            },
            data: {
              exerciseId: this.data._id,
              title,
              bots: fixBots,
              answers: fixAnswers,
              backgroundStore: cleanBackgroundStore,
              personStore: cleanPersonStore
            }
          }).then(() => {
            resolve();
          }).catch(err => {
            reject(err.response.data.error);
          })
        } else {
          axios({
            method: 'post',
            url: `${process.env.VUE_APP_SERVER_URL}saveExercise`,
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('token') 
            },
            data: {
              title,
              bots: fixBots,
              answers: fixAnswers,
              backgroundStore: cleanBackgroundStore,
              personStore: cleanPersonStore,
              shortId: uniqid()
            }
          }).then(result => {
            this.data._id = result.data.documentId;
            resolve();
          }).catch(err => {
            reject(err.response.data.error);
          })
        }

      })
    },

    getFrameData(questionId) {
      let question = this.data.bots.find(question => question.id == questionId);
      let answers = [];
      question.answers.forEach(answerId => {
        answers.push(this.data.answers.find(answer => answer.id == answerId));
      });
      let externalBackground = this.data.backgroundStore.find(background => background.name == question.background.data);
      let externalPerson = this.data.personStore.find(person => person.name == question.person.data);
      return { question, answers, externalBackground, externalPerson}
    },

    changeBottomBar(element) {
      if(element == 'question') {
        this.bottomBars.question = !this.bottomBars.question;
      } else if(element == 'answer_0') {
        this.bottomBars.answer_0 = !this.bottomBars.answer_0;
      } else if(element == 'answer_1') {
        this.bottomBars.answer_1 = !this.bottomBars.answer_1;
      } else if(element == 'answer_2') {
        this.bottomBars.answer_2 = !this.bottomBars.answer_2;
      } else if(element == 'answer_3') {
        this.bottomBars.answer_3 = !this.bottomBars.answer_3;
      }
    },

    goQuestion(payload) {
      if(this.$refs[payload][0].$el.offsetHeight < window.innerHeight) {
        this.$refs[payload][0].$el.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
      } else {
        this.$refs[payload][0].$el.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
      }
    },

    deleteQuestion(questionId) {
      let questionIndex = this.data.bots.findIndex(question => question.id == questionId);
      let answers = this.data.answers.filter(answer => answer.next == questionId);
      answers.forEach(answer => answer.next = null);
      this.data.bots.splice(questionIndex, 1);
    },

    init() {
      this.$set(this.data, '_id', null);
      this.$set(this.data, 'activePlayModes', {
        learn: true,
        play: true,
        record: true
      });
      this.$set(this.data, 'answers', []);
      this.$set(this.data, 'autoContinue', true);
      this.$set(this.data, 'backgroundStore', []);
      this.$set(this.data, 'blockCopy', false);
      this.$set(this.data, 'bots', []);
      this.$set(this.data, 'personStore', []);
      this.$set(this.data, 'title', 'Untitled exercise');
    },

    createFirstQuestion() {
      let id = uniqid();
      let question = {
        id: id,
        text: '',
        audioData: null,
        answers: [],
        audioType: 'bot',
        recordingTime: 0,
        background: { type: 'color', data: '#194d33' },
        person: { type: null },
        selectedVoice: { name: 'Google UK English Male', lang: 'en-GB' },
      };
      this.$set(this.data.bots, 0, question);
      this.loading = false;
    }

  },
  created() {
    this.playerStop();
    this.init();
    this.createFirstQuestion();
  },
  computed: {

  },
  beforeRouteEnter(to, from, next) {
    axios({
      method: 'post',
      url: `${process.env.VUE_APP_SERVER_URL}limitEditing`,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') 
      },
    }).then(() => {
      next();
    }).catch(() => {
      console.log('Limit Error');
      alert.showError('Dialog limit reached');
      if(!from.name) {
        next('/main');
      }
    })
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  min-height: 100vh;
  background-color: rgb(62, 64, 70);
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow-x: hidden;
}

.loading {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.content {
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  height: auto;
}

.editor {
  width: 80rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 1rem;
  padding-bottom: 3rem;

  @media (max-width: 1350px) {
    width: 70rem;
  }
  @media (max-width: 1150px) {
    width: 65rem;
  }
  @media (max-width: 1050px) {
    width: 62rem;
    padding-top: unset;
  }
  @media (max-width: 1000px) {
    width: 95vw;
  }
}
</style>